export default "__VITE_ASSET__ed7c1f89__"